import React, { useState, useEffect } from 'react';
import styles from './TemplateHero1.module.css';

const TemplateHero1 = ({ branding, heroData }) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  // 👇 Completely dynamic. Safely extracts slides or defaults to an empty array.
  const slides = heroData?.slides || [];

  // Auto-play slider logic
  useEffect(() => {
    if (slides.length <= 1) return; // Don't slide if there's only 1 image (or 0)

    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000); // Changes slide every 5 seconds

    return () => clearInterval(interval);
  }, [slides.length]);

  // 👇 Graceful fallback: If the agent has NO slides, don't crash, just hide the section.
  if (slides.length === 0) return null;

  return (
    <div className={styles.heroContainer}>
      {/* Background Slides */}
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`${styles.slide} ${index === currentSlide ? styles.activeSlide : ''}`}
          style={{ backgroundImage: `url('${slide.image}')` }}
        >
          {/* Overlay to make text readable */}
          <div className={styles.overlay}></div>
        </div>
      ))}

      {/* Content (Text & Buttons) */}
      <div className={styles.contentWrapper}>
        {/* We only render the text of the CURRENT slide to enable animations */}
        <h1 className={styles.title} key={`title-${currentSlide}`}>
          {slides[currentSlide].title}
        </h1>
        
        <p className={styles.subtitle} key={`sub-${currentSlide}`}>
          {slides[currentSlide].subtitle}
        </p>
        
        <div className={styles.buttonGroup}>
          <button className={`btn btn-primary btn-lg rounded-pill px-4 ${styles.primaryBtn}`}>
            Explore Now
          </button>
          <button className={`btn btn-outline-light btn-lg rounded-pill px-4 ${styles.outlineBtn}`}>
            Learn More
          </button>
        </div>
      </div>

      {/* Slider Indicators (Dots) - Only show if > 1 slide */}
      {slides.length > 1 && (
        <div className={styles.indicators}>
          {slides.map((_, index) => (
            <span
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`${styles.dot} ${index === currentSlide ? styles.activeDot : ''}`}
            ></span>
          ))}
        </div>
      )}
    </div>
  );
};

export default TemplateHero1;